import { useState } from 'react';
import {
  Users,
  FileText,
  Building,
  Tag,
  Video,
  Sliders,
  Home,
  MapPin,
  Mail,
  Calendar,
  BarChart3, // 👈 icône pour Analytics
} from 'lucide-react';

import MembersTable from '../components/admin/MembersTable';
import GrievancesTable from '../components/admin/GrievancesTable';
import LandlordsTable from '../components/admin/LandlordsTable';
import ThemesTable from '../components/admin/ThemesTable';
import AdminVideos from '../components/admin/AdminVideos';
import LiveStreamManager from '../components/admin/LiveStreamManager';
import ActionsTable from '../components/admin/ActionsTable';
import SliderManager from '../components/admin/SliderManager';
import AgencesTable from '../components/admin/AgencesTable';
import AdminPayment from '../components/admin/AdminPayment';
import AdminNewsletter from '../components/admin/Newsletter';
import AdminAppointments from '../components/admin/AdminAppointments';
import AdminPendingUsersPage from '../components/admin/AdminPendingUsersPage'; 
import AdminAnalytics from '../components/admin/AdminAnalytics.jsx';
import '../styles/AdminDashboard.css';


// ⭐ AJOUT : Lien externe vers la page /stats
const openStatsPage = () => {
  window.open('https://nms06.com/stats', '_blank'); // Ouvre dans un nouvel onglet
};


const tabs = [
  { id: 'members', name: 'Membres', icon: Users },
  { id: 'pending_users', name: 'Utilisateurs en attente', icon: Mail }, 
  { id: 'grievances', name: 'Signalements', icon: FileText },
  { id: 'landlords', name: 'Propriétaires', icon: Building },
  { id: 'themes', name: 'Thèmes', icon: Tag },
  { id: 'videos', name: 'Vidéos', icon: Video },
  { id: 'livestream', name: 'Live Stream', icon: Video },
  { id: 'actions', name: 'Actions', icon: FileText },
  { id: 'sliders', name: 'Sliders', icon: Sliders },
  { id: 'paypal', name: 'Paiement', icon: Home },
  { id: 'agences', name: 'Agences', icon: MapPin },
  { id: 'newsletter', name: 'Newsletter', icon: Mail },
  { id: 'appointments', name: 'Rendez-vous', icon: Calendar },
  { id: 'analytics', name: 'Analytics', icon: BarChart3 }, // 👈 NEW
  // ⭐ NOUVEL ONGLET SPÉCIAL (ouvre un lien, pas une page React)
  { id: 'stats_link', name: 'Stats', icon: BarChart3, external: true }
];


export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('members');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleTabClick = (tab) => {
    if (tab.external) {
      openStatsPage(); // ouvre /stats
    } else {
      setActiveTab(tab.id);
    }
  };

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1>Tableau de bord</h1>
      </div>

      <div className="dashboard-content">
        
        <div className="dashboard-navigation">

          {/* MENU MOBILE */}
          <div className="mobile-menu-button">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="menu-button"
            >
              <span>Menu</span>
              <span className="active-tab">
                {tabs.find((tab) => tab.id === activeTab)?.name}
              </span>
            </button>
          </div>

          {isMobileMenuOpen && (
            <div className="mobile-menu-dropdown">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab)}
                  className={`menu-item ${activeTab === tab.id ? 'menu-item-active' : ''}`}
                >
                  <tab.icon className="menu-icon" />
                  {tab.name}
                </button>
              ))}
            </div>
          )}

          {/* MENU DESKTOP */}
          <nav className="desktop-navigation">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab)}
                className={`desktop-menu-item ${
                  activeTab === tab.id ? 'active' : ''
                }`}
              >
                <tab.icon className="desktop-menu-icon" />
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        <div className="dashboard-content-area">
          {activeTab === 'members' && <MembersTable />}
          {activeTab === 'pending_users' && <AdminPendingUsersPage />}
          {activeTab === 'grievances' && <GrievancesTable />}
          {activeTab === 'landlords' && <LandlordsTable />}
          {activeTab === 'themes' && <ThemesTable />}
          {activeTab === 'videos' && <AdminVideos />}
          {activeTab === 'livestream' && <LiveStreamManager />}
          {activeTab === 'actions' && <ActionsTable />}
          {activeTab === 'sliders' && <SliderManager />}
          {activeTab === 'paypal' && <AdminPayment />}
          {activeTab === 'agences' && <AgencesTable />}
          {activeTab === 'newsletter' && <AdminNewsletter />}
          {activeTab === 'appointments' && <AdminAppointments />}
          {activeTab === 'analytics' && <AdminAnalytics />}

          {/* ⭐ Aucun rendu React pour "stats" car c'est un lien externe */}
        </div>

      </div>
    </div>
  );
}
